export default __webpack_public_path__ + "static/backgroundNewsletter-6524ff500d3fa2aaae67707120fee438.jpg";